import React from 'react';
import './skeletonImg.scss'; // Стили для компонента-костяшки

const SkeletonImg = () => {
  return (
    <div className="skeleton">
      <div className="skeleton-block"></div>
    </div>
  );
};

export default SkeletonImg;